import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage warm-glow field-grid py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-189" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-190" data-mp="2vqr69zq2hz5k">
        <div className="text-center" data-id="element-191" data-mp="2vownaqycwh44">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-192" data-mp="39hvyigr3vp5v">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-onDark" data-id="element-193" data-mp="35g0x7c96dbs3">
            Sunday at 11 p.m. Tomorrow you have geology class. And you're still searching for the best way to explain
            earthquake mechanisms, volcanic processes, and mineral crystallization without losing your students'
            attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-mutedDark" data-id="element-194" data-mp="1k3r7y7badfr5">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-10 rounded-xl border border-lineDark p-6 sm:p-8" data-id="element-195" data-mp="sd04u4jzu8cg">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-xl font-bold text-white" data-id="element-196" data-mp="171efv2rkd343">
            <AlertTriangleIcon className="h-5 w-5 text-goldLight" aria-hidden="true" data-id="element-197" data-mp="1c2alplvh6zc5" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-198" data-mp="3dtnmbyqeul2e">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-199" data-mp="3huha8s3urzva">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-danger" aria-hidden="true" data-id="element-200" data-mp="p0921ualpeg4" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-201" data-mp="y0yssjl08emz">
          <p className="text-lg font-bold text-goldLight" data-id="element-202" data-mp="y208j1cytpb1">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-203" data-mp="17y36rw4p53sp">Plan your entire year today.</p>
        </div>
      </div>
    </section>;
}